// extracted by mini-css-extract-plugin
export var completionBody = "_ms-2";
export var completionCard = "_ms-0";
export var completionFooter = "_ms-3";
export var completionTitle = "_ms-1";